// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-card-stat{text-align:center;margin:1rem 4rem}.vx-card-stat__value{font-size:2.2rem;font-weight:700}.vx-card-stat__unit{font-size:1.2rem}.vx-card-stat__label{font-size:1rem}\n", ""]);
// Exports
module.exports = exports;
